<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="adqAdvertListParams.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">广告主名称：</label>
          <el-input
            v-model="adqAdvertListParams.advertiser_name"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">项目ID：</label>
          <el-input
            v-model="adqAdvertListParams.project_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">项目名称：</label>
          <el-input
            v-model="adqAdvertListParams.name"
            placeholder="请输入内容"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="searchTencentAdqAdver"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="info"
          plain
          icon="el-icon-refresh-left"
          @click="resetTencentAdqAdverList"
        >
          重置
        </el-button>
        <div style="float: right">
          <el-button
            class="filter-item"
            type="info"
            plain
            @click="materialSyncbut"
          >
            <i
              class="imgIcon"
              :style="`background-image: url(${imglist[0]})`"
            />同步资产
          </el-button>
          <el-button
            type="info"
            plain
            class="filter-item"
            :disabled="!isShow"
            @click="handleCopyTencentAdqAdver(adgroup_items, 'batch')"
          >
            <i
              class="imgIcon"
              :style="`background-image: url(${imglist[1]})`"
            />批量复制
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="adqAdvertList"
        :row-class-name="'aaaa'"
        :row-key="getRowKeys"
        style="width: 100%; justify-content: space-between"
        @select="multipleChoice"
        @select-all="multipleChoice"
      >
        <el-table-column
          type="selection"
          width="55"
          :data-index="1"
          :reserve-selection="true"
        />
        <el-table-column
          prop="id"
          label="id"
          align="center"
          width="80"
        />
        <el-table-column
          prop="account_id"
          label="广告主id"
          align="center"
          width="180"
        />
        <el-table-column
          prop="advertiser_name"
          label="广告主名称"
          align="center"
          width="180"
        />
        <el-table-column
          prop="name"
          label="项目名称"
          align="center"
          width="180"
        />
        <el-table-column
          prop="project_id"
          label="项目ID"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="项目状态"
          align="center"
          width="180"
        >
          <template scope="scope">
            <div>
              <p
                class="overflow"
                :title="scope.row.status_text"
              >
                <span
                  :style="{
                    backgroundColor: getColorRgba(scope.row.status_text),
                    color: getColor(scope.row.status_text)
                  }"
                  class="account_status_text-dev"
                >
                  {{ scope.row.status_text }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="status_first_text"
          label="项目一级状态"
          align="center"
        />-->
        <!-- <el-table-column
          prop="status_second"
          label="项目二级状态"
          align="center"
        /> -->
        <el-table-column
          label="广告计划"
          align="center"
        ><template scope="scope"><el-button
          type="text"
          @click="AdInfo(scope.row)"
        >查看广告计划详情</el-button></template></el-table-column>
        <el-table-column
          prop="pricing"
          label="出价方式"
          align="center"
        />
        <el-table-column
          prop="package_name"
          label="应用包名"
          align="center"
        />
        <el-table-column
          prop="app_name"
          label="应用名"
          align="center"
        />
        <el-table-column
          prop="audience_extend"
          label="定向拓展"
          align="center"
        />
        <el-table-column
          prop="delivery_mode_text"
          label="投放模式"
          align="center"
        />
        <el-table-column
          prop="delivery_type_text"
          label="投放类型"
          align="center"
        />
        <el-table-column
          prop="landing_type_text"
          label="推广目的"
          align="center"
        >
          <template scope="scope">
            <div>
              <span
                :class="{
                  dot: true,
                  'green-dot': scope.row.landing_type_text === '小程序',
                  'red-dot': scope.row.landing_type_text === '销售线索推广'
                }"
              />{{ scope.row.landing_type_text }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="marketing_goal"
          label="营销场景"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.marketing_goal == 'VIDEO_AND_IMAGE'
                ? '短视频/图片'
                : '直播'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ad_type"
          label="广告类型"
          align="center"
        >
          <template scope="scope">
            {{ scope.row.ad_type == 'ALL' ? '所有广告' : '搜索广告' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="opt_status"
          label="目标操作"
          align="center"
        >
          <template scope="scope">
            {{ scope.row.opt_status == 'ENABLE' ? '启用项目' : '暂停项目' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="feed_delivery_search"
          label="搜索快投关键词功能"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.feed_delivery_search == 'HAS_OPEN' ? '启用' : '未启用'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="dpa_categories"
          label="商品投放范围"
          align="center"
        />
        <el-table-column
          prop="dpa_adtype"
          label="自定义筛选条件（商品投放条件）"
          align="center"
        />
        <el-table-column
          prop="dpa_categories"
          label="DPA广告类型"
          align="center"
        />
        <el-table-column
          prop="download_url"
          label="下载链接"
          align="center"
        />
        <el-table-column
          prop="download_type"
          label="下载方式"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.download_type == 'DOWNLOAD_URL'
                ? '直接下载'
                : '落地页下载'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="download_mode"
          label="下载模式"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.download_mode == 'APP_STORE_DELIVERY'
                ? '优先商店下载'
                : '默认下载'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="launch_type"
          label="下载模式"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.launch_type == 'AWEME_HOME_PAGE' ? '抖音主页' : '落地页'
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="open_url"
          label="Deeplink直达链接"
          align="center"
        />
        <el-table-column
          prop="ulink_url"
          label="ulink直达链接"
          align="center"
        />
        <el-table-column
          prop="download_url"
          label="下载链接"
          align="center"
        />
        <el-table-column
          prop="subscribe_url"
          label="预约下载链接"
          align="center"
        />
        <el-table-column
          prop="open_url_type"
          label="直达链接类型"
          align="center"
        />
        <el-table-column
          prop="open_url_field"
          label="直达链接字段选择"
          align="center"
        />
        <el-table-column
          prop="open_url_params"
          label="直达链接检测参数"
          align="center"
        />
        <el-table-column
          prop="budget_group_id"
          label="项目关联的预算组ID"
          align="center"
        />
        <el-table-column
          prop="asset_type_text"
          label="资产类型"
          align="center"
        />
        <el-table-column
          prop="micro_promotion_type"
          label="小程序类型"
          align="center"
        >
          <template scope="scope">
            {{
              scope.row.micro_promotion_type == 'BYTE_APP'
                ? '字节小程序'
                : scope.row.micro_promotion_type == 'BYTE_GAME'
                  ? '字节小游戏'
                  : scope.row.micro_promotion_type == 'WECHAT_APP'
                    ? ' 微信小程序 '
                    : ' 微信小游戏'
            }}
          </template></el-table-column>
        <el-table-column
          prop="dpa_product_target"
          label="项目创建时间"
          align="center"
          width="180"
        />
        <!-- <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="200"
          >
            <template scope="scope">
              <el-button
                type="primary"
                @click="linkskip(scope.row)"
              >复制列表</el-button>
            </template>
          </el-table-column> -->
        <el-table-column
          fixed="right"
          label="操作"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleCopyTencentAdqAdver(scope.row)"
            >
              复制
            </el-button>
            <el-button
              type="warning"
              size="mini"
              @click="handleCopyTencentbinse(scope.row)"
            >
              复制变色龙
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <!-- <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="pull" @addPull="addPull" />
    </el-dialog> -->
    <!-- <el-dialog
      title="广告"
      :visible.sync="dialogVisibleadr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <addAD ref="addadview" @updata="updata" />
    </el-dialog> -->
    <el-drawer
      title="广告计划详情信息"
      :visible.sync="drawer"
      direction="btt"
    >
      <el-table
        :data="ad_info"
        border
      >
        <el-table-column
          prop="opt_status"
          label="开启状态"
        />
        <el-table-column
          prop="promotion_id"
          label="广告id"
        />
        <el-table-column
          prop="promotion_name"
          label="广告名称"
        />
        <el-table-column
          prop="status"
          label="广告状态"
        />
      </el-table>
    </el-drawer>
    <CopyAdqAdDialog
      ref="copyAdqAdDialog"
      :adgroup_ids="adgroup_ids"
      @qindian="quedian"
      @guanbi="alone = null"
    />
    <CopyAdqAdDialogtwo
      ref="copyAdqAdDialogview"
      :adgroup_ids="adgroup_ids"
      @quediantwo="quediantwo"
      @guanbi="aloneall = null"
    />
    <el-dialog
      title="同步账户资产"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body
    >
      <accoutIdDialog
        ref="add"
        @submit="submit"
      />
    </el-dialog>
  </div>
</template>

<script>
import accoutIdDialog from './components/accoutIdDialog.vue'
import { projectIndex, job_create, oceanMaterialSync, copyv2jobcreate } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import CopyAdqAdDialog from './components/index.vue'
import CopyAdqAdDialogtwo from './components/indexbianse.vue'
import { copyAdqAdvert } from '@/api/customer/accountList/copyAdvertManage'
// import publicAdvertList from '@/views/customer/accountList/tencentAdqAdvertManage/publicAdvertList'
export default {
  components: {
    PaginationRight,
    // publicAdvertList,
    CopyAdqAdDialog,
    accoutIdDialog,
    CopyAdqAdDialogtwo
  },
  data() {
    return {
      total: null, // 数据总条数啊
      loading: false,
      loadingGlobalWindow: false,
      pageTotal: 0,
      adqAdvertListParams: {
        project_id: null,
        advertiser_name: null, // 广告主名称
        account_id: null, // 广告组名称
        name: null,
        page: null, // 当前页码
        page_size: null // 广告在系统中的状态
      },

      adqAdvertList: [],
      adgroup_ids: null,
      alone: null,
      allow_template: null,
      adgroup_items: [],
      system_statusOptions: [
        {
          value: 'ADGROUP_STATUS_FROZEN',
          label: '已冻结'
        },
        {
          value: 'ADGROUP_STATUS_SUSPEND',
          label: '暂停中'
        },
        {
          value: 'ADGROUP_STATUS_NOT_IN_DELIVERY_TIME',
          label: '广告未到投放时间'
        },
        {
          value: 'ADGROUP_STATUS_ACTIVE',
          label: '投放中'
        },
        {
          value: 'ADGROUP_STATUS_DELETED',
          label: '已删除'
        },
        {
          value: 'ADGROUP_STATUS_ACCOUNT_BALANCE_NOT_ENOUGH',
          label: '账户余额不足'
        },
        {
          value: 'ADGROUP_STATUS_DAILY_BUDGET_REACHED',
          label: '广告达到日预算上限'
        },
        {
          value: 'ADGROUP_STATUS_PARTIAL_ACTIVE',
          label: '部分投放中'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_STATUS_PENDING',
          label: '创意未投放'
        },
        {
          value: 'ADGROUP_STATUS_CREATIVE_EMPTY',
          label: '创意准备中'
        },
        {
          value: 'ADGROUP_STATUS_JOINT_BUDGET_REACHED',
          label: '广告被暂停（联合预算达上限）'
        }
      ],
      imglist: [require('@/assets/images/11.巨量3.0--项目/同步资产.png'), require('@/assets/images/11.巨量3.0--项目/批量复制.png')],
      dialogVisible: false,
      drawer: false,
      ad_info: [],
      aloneall: null
    }
  },
  computed: {
    isShow() {
      let blo = false
      console.log('this.adgroup_items:', this.adgroup_items)
      if (this.adgroup_items.length !== 0) {
        const account_id = this.adgroup_items[0].account_id
        // eslint-disable-next-line eqeqeq
        const isAllAccountIdsEqual = this.adgroup_items.every(
          // eslint-disable-next-line eqeqeq
          item => item.account_id == account_id
        )

        if (isAllAccountIdsEqual) {
          blo = true
        } else {
          blo = false
        }
      }
      return blo
    }
  },
  created() {
    this.fetchAdqAdvertList()
    // console.log(this.$route.query)
    window.aaaaa = this
  },
  methods: {
    getColor(status) {
      const color = status === '启用' ? '#22bf46' : '#ff8108'
      return color
    },
    getColorRgba(status) {
      const color = status === '启用' ? 'rgba(34, 191, 70, 0.1)' : 'rgba(255, 213, 167, 0.1)'
      return color
    },
    async submit(obj, fu) {
      await oceanMaterialSync(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    getRowKeys(row) {
      return row.id
    },
    handleCopyTencentAdqAdver(rowData, type) {
      console.log('rowDat5a:', rowData)
      // if (rowData && !this.allow_template.includes(rowData.preview_info.adcreative_template_id)) {
      //   return
      // }
      // if (!rowData) {
      //   const type = this.adgroup_items[0].promoted_object_type
      //   const newArr = this.adgroup_items.filter(item => {
      //     return item.promoted_object_type === type
      //   })

      //   var text = null
      //   if (newArr.length !== this.adgroup_items.length) {
      //     text = '目标不一致'
      //   }
      // }
      this.alone = rowData

      // this.$refs.copyAdqAdDialog.open(text || rowData || { promoted_object_type: this.adgroup_items[0].promoted_object_type })
      this.$refs.copyAdqAdDialog.open(rowData, type)
    },
    handleCopyTencentbinse(rowData, type) {
      console.log('rowDat5a:', rowData)
      this.aloneall = rowData
      this.$refs.copyAdqAdDialogview.open(rowData, type)
    },
    async quedian(obj, fu) {
      console.log('ob56565j888888:', obj)
      if (!this.loadingGlobalWindow) {
        this.loadingGlobalWindow = true
        try {
          const res = await job_create(obj)
          console.log('res:', res)
          this.$message.success(res.message)
          this.loadingGlobalWindow = false
          fu()
          this.fetchAdqAdvertList()
        } catch (error) {
          this.loadingGlobalWindow = false
        }
      }
    },
    async quediantwo(obj, fu) {
      console.log('ob56565j888888:', obj)
      if (!this.loadingGlobalWindow) {
        this.loadingGlobalWindow = true
        try {
          const res = await copyv2jobcreate(obj)
          console.log('res:', res)
          this.$message.success(res.message)
          this.loadingGlobalWindow = false
          fu()
          this.fetchAdqAdvertList()
        } catch (error) {
          this.loadingGlobalWindow = false
        }
      }
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    handleClose() {
      this.dialogVisible = false
    },
    materialSyncbut(row) {
      this.dialogVisible = true
      console.log(this.adqAdvertListParams.account_id)
      this.$nextTick(() => {
        // eslint-disable-next-line eqeqeq
        if (
          // eslint-disable-next-line eqeqeq
          this.$route.query.account_id == this.adqAdvertListParams.account_id
        ) {
          console.log(1)
          this.$refs.add.send(row, this.$route.query)
        } else {
          let obj = {}
          if (this.adqAdvertListParams.account_id !== '') {
            console.log(2, this.adqAdvertListParams.account_id)
            this.adqAdvertList.forEach(element => {
              // eslint-disable-next-line eqeqeq
              if (element.account_id == this.adqAdvertListParams.account_id) {
                obj = {
                  account_id: element.account_id,
                  account_name: element.account_name
                }
              }
            })
          }
          this.$refs.add.send(row, obj)
        }
      })
    },
    linkskip(row) {
      this.$router.push({
        path: '/tencentAD/copyRecord/index',
        query: { item: row }
      })
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      projectIndex(this.adqAdvertListParams).then(res => {
        console.log('res:', res)
        this.adqAdvertList = res.data.list
        this.total = res.data.count
        this.loading = false
        console.log(22)
      })
    },
    // 搜索公共广告
    searchTencentAdqAdver() {
      if (this.adqAdvertListParams.adgroup_name === '') {
        this.adqAdvertListParams.adgroup_name = null
      }
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    // 重置公共广告
    resetTencentAdqAdverList() {
      this.adqAdvertListParams = {
        project_id: null,
        advertiser_name: null, // 广告主名称
        account_id: null, // 广告组名称
        name: null,
        page: null, // 当前页码
        page_size: null // 广告在系统中的状态
      }
      this.fetchAdqAdvertList()
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.adgroup_ids = arr.map(item => {
        return item.account_id
      })
      this.adgroup_items = arr
    },
    async qindian(data1, func) {
      // let obj = null
      // 判断是否不是批量复制
      // if (this.alone) {
      //   obj = {
      //     origin: '2',
      //     account_id: this.$route.query.account_id,
      //     account_ids: data1,
      //     adgroup_ids: [this.alone.adgroup_id]
      //   }
      // } else {
      //   obj = {
      //     origin: '2',
      //     account_id: this.$route.query.account_id,
      //     account_ids: data1,
      //     adgroup_ids: this.adgroup_ids
      //   }
      // }
      copyAdqAdvert(data1)
        .then(data => {
          this.$message({
            message: data.message,
            type: 'success'
          })
          func()
        })
        .catch(data => {
          this.$message({
            message: `${data.message}`,
            type: 'error'
          })
        })
    },
    // loadTheFirstPin(list) {
    //   for (let i = 0; i < list.length; i++) {
    //     if (!list[i].preview_info.img && list[i].preview_info.video) {
    //       diyi(list[i].preview_info, list[i].preview_info.video)
    //     }
    //   }

    //   const This = this

    //   function diyi(obj, src) {
    //     var videoElement = document.createElement('video')
    //     videoElement.src = src
    //     videoElement.addEventListener('canplay', function () {
    //       var canvas = document.createElement('canvas')
    //       canvas.width = videoElement.videoWidth
    //       canvas.height = videoElement.videoHeight
    //       canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height)
    //       var firstFrame = canvas.toDataURL('image/png') // 第一帧图片url
    //       This.$set(obj, 'firstStitch', firstFrame)
    //     })
    //   }
    // },
    checkSelect(row, index) {
      return this.allow_template.includes(row.preview_info.adcreative_template_id)
    },
    AdInfo(val) {
      this.drawer = true
      this.ad_info = val.promotion
      console.log(this.ad_info)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.titip {
  width: 154px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  overflow: hidden;
}
</style>
<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}
.imgIcon {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  background-size: cover;
  // filter: hue-rotate(90deg);
  filter: grayscale(100%);
}
.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.dot {
  display: inline-block;
  margin: 0 5px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-left: 5px;
}
.green-dot {
  background-color: green;
}

.red-dot {
  background-color: #f77234;
}
.account_status_text-dev {
  // background-color: rgba(95, 252, 95, 0.1);
  padding: 12px;
  // color: #22bf46;
}
.dropdown-content {
  // display: none;
  position: absolute;
  top: 50px;
  right: 0;
  background-color: #fff;
  width: 100%;
  border: 1px solid #ccc;
  // padding: 10px 20px;
  z-index: 99999;
  border-radius: 8px;
}

.show {
  display: block;
}
.dropdown-item {
  height: 35px;
  line-height: 35px;
}

.dropdown-item:hover {
  color: #195ffe;
}
</style>
